import ApiBase from '../../api-base'
import {ACTIVE_BASE_REST} from '../../constants'
export default class TariffItem extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/tariff/record/employee'
        super(store, path)
    }

}